module.exports = __webpack_public_path__ + "static/media/nypost.com_2016_08_27_its-digital-heroin-how-screens-turn-kids-into-psychotic-junkies__plot.1ad272a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nypost.com_2016_08_27_its-digital-heroin-how-screens-turn-kids-into-psychotic-junkies__plot.png
// module id = 403
// module chunks = 0